module.exports = __webpack_public_path__ + "img/jami.78587fe5.jpg";